import { useState } from "react";
import { Plus } from "lucide-react";
import { GSDocumentToolNavbar } from "@/components/layout/GSDocumentToolNavbar";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useUserProducts } from "@/hooks/useUserProducts";
import { AddGSProductDialog } from "@/components/gs-document-tool/AddGSProductDialog";
import { GSProductCard } from "@/components/gs-document-tool/GSProductCard";

export default function GSDocumentTool() {
  const [showAddDialog, setShowAddDialog] = useState(false);
  const { products, isLoading } = useUserProducts();

  return (
    <div className="min-h-screen bg-background">
      <GSDocumentToolNavbar />
      
      <main className="container mx-auto px-4 py-8">
        <div className="mb-8">
          <h1 className="text-3xl font-bold mb-2">GS Document Tool</h1>
          <p className="text-muted-foreground">
            Manage your products and their Green Seal standard compliance
          </p>
        </div>

        <div className="flex justify-between items-center mb-6">
          <h2 className="text-xl font-semibold">Your Products</h2>
          <Button onClick={() => setShowAddDialog(true)}>
            <Plus className="h-4 w-4 mr-2" />
            Add Product
          </Button>
        </div>

        {isLoading ? (
          <div className="grid gap-4">
            {[1, 2, 3].map((i) => (
              <Card key={i} className="animate-pulse">
                <CardHeader>
                  <div className="h-4 bg-muted rounded w-1/3"></div>
                </CardHeader>
                <CardContent>
                  <div className="h-3 bg-muted rounded w-2/3 mb-2"></div>
                  <div className="h-3 bg-muted rounded w-1/2"></div>
                </CardContent>
              </Card>
            ))}
          </div>
        ) : products.length === 0 ? (
          <Card>
            <CardContent className="flex flex-col items-center justify-center py-12">
              <div className="text-center">
                <h3 className="text-lg font-medium mb-2">No products yet</h3>
                <p className="text-muted-foreground mb-4">
                  Get started by adding your first product
                </p>
                <Button onClick={() => setShowAddDialog(true)}>
                  <Plus className="h-4 w-4 mr-2" />
                  Add Your First Product
                </Button>
              </div>
            </CardContent>
          </Card>
        ) : (
          <div className="grid gap-4">
            {products.map((product) => (
              <GSProductCard key={product.id} product={product} />
            ))}
          </div>
        )}

        <AddGSProductDialog 
          open={showAddDialog}
          onOpenChange={setShowAddDialog}
        />
      </main>
    </div>
  );
}